import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faEdit,
  faFilter,
  faPencil,
  faRefresh,
  faSortDown,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import Compare_Lottie from "../../animation/Compare_Lottie/Compare_Lottie";
import Back_Btn from "../Common_Btn/Back_Btn/Back_Btn";
import { Dropdown } from "react-bootstrap";
import "./Second_Header.css";
import Edit_Profile_OffCanvas from "../../Edit_Profile_OffCanvas/Edit_Profile_OffCanvas";
import ComparePlansModal from "../Common_Modal/ComparePlansModal/ComparePlansModal";
import Filter_Sort_By_Modal from "../Common_Modal/Filter_Sort_By_Modal/Filter_Sort_By_Modal";
import { useNavigate } from "react-router-dom";
import Enter_Payout_Modal from "../Common_Modal/Enter_Payout_Modal/Enter_Payout_Modal";
import You_Are_Almost_There_Modal from "../Common_Modal/You_Are_Almost_There_Modal/You_Are_Almost_There_Modal";
import { getAge } from "../../../utils/common";

const Second_Header = ({
  insuranceData,
  lifecoverdata,
  setLifecover,
  setCoverTillAge,
  coverTillAge,
  setData,
  data,
  ...props
}) => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showComparePlanModal, setShowComparePlanModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const navigate = useNavigate();

  const [showAmountModal, setShowAmountModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const lifecover = [
    "25 Lac",
    "30 Lac",
    "35 Lac",
    "40 Lac",
    "45 Lac",
    "50 Lac",
    "55 Lac",
    "60 Lac",
    "65 Lac",
    "70 Lac",
    "75 Lac",
    "80 Lac",
    "85 Lac",
    "90 Lac",
    "95 Lac",
    "1 Cr",
  ];

  const yrsArray = [
    "44 Yrs",
    "45 Yrs",
    "46 Yrs",
    "47 Yrs",
    "48 Yrs",
    "49 Yrs",
    "50 Yrs",
    "51 Yrs",
    "52 Yrs",
    "53 Yrs",
    "54 Yrs",
    "55 Yrs",
    "56 Yrs",
    "57 Yrs",
    "58 Yrs",
    "59 Yrs",
    "60 Yrs",
    "61 Yrs",
    "62 Yrs",
    "63 Yrs",
    "64 Yrs",
    "65 Yrs",
    "66 Yrs",
    "67 Yrs",
    "68 Yrs",
    "69 Yrs",
    "70 Yrs",
    "71 Yrs",
    "72 Yrs",
    "73 Yrs",
    "74 Yrs",
    "75 Yrs",
  ];

  const getIncomeRange = (income) => {
    const incomeValue = parseInt(income, 10); // Convert income string to number

    if (incomeValue < 200000) return "Less than 2 Lac";
    if (incomeValue >= 200000 && incomeValue < 300000) return "2 - 3 Lac";
    if (incomeValue >= 300000 && incomeValue < 400000) return "3 - 4 Lac";
    if (incomeValue >= 400000 && incomeValue < 500000) return "4 - 5 Lac";
    if (incomeValue >= 500000 && incomeValue < 600000) return "5 - 6 Lac";
    if (incomeValue >= 600000 && incomeValue < 700000) return "6 - 7 Lac";
    if (incomeValue >= 700000 && incomeValue < 800000) return "7 - 8 Lac";
    if (incomeValue >= 800000 && incomeValue < 900000) return "8 - 9 Lac";
    if (incomeValue >= 900000 && incomeValue < 1000000) return "9 - 10 Lac";
    if (incomeValue >= 1000000 && incomeValue < 2000000) return "10 - 20 Lac";
    if (incomeValue >= 2000000 && incomeValue < 3000000) return "20 - 30 Lac";
    return "30+ Lac"; // For values above 30 Lac
  };

  console.log(lifecoverdata, "lifecoverdata lifecoverdata");

  return (
    <div className="second_header_section">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 col-md-12 me-0 ms-0 p-0">
            <div className="left_side_part">
              {props?.showFilter ? (
                <div className="filter_holder">
                  <div className="d-flex">
                    <div className="live_cover_holder">
                      <Dropdown>
                        <Dropdown.Toggle
                          id="dropdown-basic"
                          className="custom-dropdown"
                        >
                          <div className="dropdown-content">
                            <p className="dropdown_title">Life Cover</p>
                            <p className="dropdown_value">{lifecoverdata}</p>
                          </div>

                          <div className="icon_holder">
                            <FontAwesomeIcon
                              icon={faSortDown}
                              className="down_icon"
                            />
                          </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {lifecover?.map((item) => {
                            return (
                              <Dropdown.Item
                                href="#/action-1"
                                onClick={() => setLifecover(item)}
                              >
                                {item}
                              </Dropdown.Item>
                            );
                          })}

                          {/* <div
                            className="custom_btn"
                            onClick={() => {
                              setShowAmountModal(true);
                            }}
                          >
                            Enter Custom
                          </div> */}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>

                    <div className="cover_till_holder">
                      <Dropdown>
                        <Dropdown.Toggle
                          id="dropdown-basic"
                          className="custom-dropdown"
                        >
                          <div className="dropdown-content">
                            <p className="dropdown_title">Cover Till</p>
                            <p className="dropdown_value">{coverTillAge} of Age</p>
                          </div>

                          <div className="icon_holder">
                            <FontAwesomeIcon
                              icon={faSortDown}
                              className="down_icon"
                            />
                          </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {yrsArray?.map((item) => (
                            <Dropdown.Item
                              href="#/action-1"
                              onClick={() => setCoverTillAge(item)}
                            
                            >
                              {item}
                            </Dropdown.Item>
                          ))}

                          <div className="custom_btn"   onClick={() => setCoverTillAge("100")}>Switch to Whole Life</div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    
                    <div
                    className="filter_sort_holder"
                    
                  >
                    <button type="button" className="filter_btn">
                      <FontAwesomeIcon
                        icon={faRefresh}
                        className="filter_icon m-0"
                      />
                    </button>
                  </div>
                  </div>

                 

                  {/* <div
                    className="filter_sort_holder"
                    onClick={() => {
                      setShowFilterModal(true);
                    }}
                  >
                    <button type="button" className="filter_btn">
                      Filter / Sort by
                      <FontAwesomeIcon
                        icon={faFilter}
                        className="filter_icon"
                      />
                    </button>
                  </div> */}
                </div>
              ) : (
                <div className="back_btn_holder">
                  <Back_Btn
                    btn_name="Back"
                    onClick={() => {
                      navigate("/loan-compare");
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="col-lg-7 col-md-12 me-0 ms-0 p-0">
            <div className="blue_bg_holder">
              {props?.showCompare && (
                <div
                  className="user_info_main_div compare"
                  onClick={() => {
                    setShowComparePlanModal(true);
                  }}
                >
                  <div className="icon_holder">
                    <Compare_Lottie />
                  </div>
                  <div className="text_info_holder">
                    <p className="para_text">Plan Compare</p>
                  </div>
                </div>
              )}

              <div className="user_info_main_div">
                <div className="icon_holder">
                  <FontAwesomeIcon icon={faUser} className="user_icon" />
                </div>
                <div className="text_info_holder">
                  <p className="para_text">{data?.gender}</p>

                  <p className="para_text">{getAge(data?.dob)}</p>

                  <p className="para_text">
                    {data?.smoke_status === 0 ? " Non Smoker" : "Smoker"}
                  </p>

                  <p className="para_text">{getIncomeRange(data?.income)}</p>
                </div>
              </div>

              <div
                className="edit_icon_holder"
                onClick={() => setShowOffcanvas(true)}
              >
                <FontAwesomeIcon icon={faPencil} className="edit_icon" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Edit_Profile_OffCanvas
        setData={setData}
        data={data}
        show={showOffcanvas}
        onHide={() => setShowOffcanvas(false)}
      />

      <ComparePlansModal
        insuranceData={insuranceData}
        data={data}
        show={showComparePlanModal}
        onHide={() => setShowComparePlanModal(false)}
      />

      <Filter_Sort_By_Modal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        setShowSuccessModal={setShowSuccessModal}
      />

      <Enter_Payout_Modal
        show={showAmountModal}
        onHide={() => setShowAmountModal(false)}
      />

      <You_Are_Almost_There_Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
      />
    </div>
  );
};

export default Second_Header;
